import { render, staticRenderFns } from "./SaturatedWaterVaporComponent.vue?vue&type=template&id=22018a7b&"
import script from "./SaturatedWaterVaporComponent.vue?vue&type=script&lang=js&"
export * from "./SaturatedWaterVaporComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports